import underline from "../media/pen-underline.png"
import Nav from "../components/nav";
import FooterComp from "../components/footer";
import "../css/services.css"
import { useNavigate } from "react-router-dom";
import useGenStore from "../store/store";
import { useEffect } from "react";
import Fonav from "../components/fonnav";
import Aos from "aos";
import "aos/dist/aos.css";

function Services() {
const navigate= useNavigate()
  const menuActive = useGenStore((s)=>s.menuActive)
  const toContact =()=>{
    navigate("/contact")
  }
    useEffect(() => {
      Aos.init({ duration: 400 });
    }, []);
  return (

    <>
      <helmet>
        <title>Employer Legal Counsel | HR Compliance & Training</title>
        <meta
          name="description"
          content="Employment law attorney helping employers with compliance, training, investigations & government agency responses."
        />
      </helmet>
      <div className="floatBtn">
            <button onClick={()=>( window.location.href = "tel:+13602974057")}>Call Now</button>
        </div>
      <div className= {`floatNav ${menuActive ? "floatNavActive":""}`} >
            <Fonav />
        </div>
      <div className="IntroPage">
        <nav>
          <Nav />
        </nav>
        <div className="introWrap">
          <h2>Services</h2>
          <img src={underline} alt="" />
        </div>
      </div>

      <div className="services1">
        <div className="servicePlacer">
            <div className="serveLeft">
               <h3>Employee <span>Side</span> </h3>
               <p>If you are an employee who believes
your rights have been violated please
give me a call or drop an email. I can
assist you with:</p>
            </div>
            <div className="serveRight">
                <div className="serveRightBox" data-aos="fade-up">
                   <ul>
  <li>Wage & Hour Violations</li>
  <li>Misclassification of Employment</li>
  <li>Class Action Lawsuits</li>
  <li>Overtime Violations</li>
  <li>Discrimination</li>
  <li>Wrongful Termination</li>
  <li>Harassment</li>
  <li>Unfair Non-Compete Agreements</li>
  <li>Negotiating Employment Agreement</li>
  <li>Negotiating Severance Packages</li>
</ul>
<button onClick={()=>toContact()}>Request Consultation</button>
                </div>

            </div>
        </div>
      </div>
      <div className="services2">
        <div className="servicePlacer">
            <div className="serveLeft">
               <h3>Employer <span>Side</span> </h3>
               <p>If you are an employer who is faced
with a legal issue I can help. If you are
looking to get ahead of legal issues or
new legal requirements give me a call.
Counsel and advice is never more than
a phone call away.

I can assist you with:

</p>
            </div>
            <div className="serveRight" data-aos="fade-up">
                <div className="serveRightBox">
                  <ul>
  <li>Proper Hiring procedures</li>
  <li>Wage & Hour compliance</li>
  <li>I-9 procedures</li>
  <li>Family Medical Leave & ADA compliance</li>
  <li>Responses to Government agencies such as ESD, DOL, L & I and EEOC matters.</li>
  <li>Training on Employee Management, Discipline, Investigations & Communications.</li>
</ul>

<button onClick={()=>toContact()}>Request Consultation</button>
                </div>

            </div>
        </div>
      </div>
 
      <footer>
        <FooterComp/>
      </footer>
    </>
  );
}

export default Services;